<template>
	<div class="usuariolead">
		<loader object="#df3e46" v-show="progress" color1="#0db9d3" color2="#fff01f" size="6" speed="2.4" bg="#C0C0C0"
			objectbg="#0d0c0d" opacity="50" name="circular"></loader>

		<div class="container-fluid">
			<ol class="breadcrumb-arrow">
				<li>
					<a href="/home"><i class="fa fa-home"></i></a>
					<a href="#">Usuários do sistema</a>
				</li>
			</ol>
		</div>

		<div class="container-fluid mt-2">

			<ul class="nav nav-tabs" id="myTab" role="tablist">
				<li class="nav-item">
					<a class="nav-link active" @click="habilitaCoordenacao(false)" id="pendente-tab" data-toggle="tab" href="#pendente" role="tab"
						aria-controls="pendente" aria-selected="true">
						Usuários pendentes
					</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" @click="habilitaCoordenacao(true)" id="aprovados-tab" data-toggle="tab" href="#aprovados" role="tab"
						aria-controls="aprovados" aria-selected="false">
						Usuários ativos
					</a>
				</li>
				<div class="col text-right">
					<el-tooltip content="Adicionar usuário" placement="top">
						<button type="button" class="btn btn-primary" @click="abrirModalAddUsuario()">
							<i class="fas fa-plus-circle mr-2"></i>
							Usuário
						</button>
					</el-tooltip>
				</div>
			</ul>
			<div class="tab-content" id="myTabContent">
				<!-- Usuários Pendentes -->
				<div class="mt-2 tab-pane fade show active" id="pendente" role="tabpanel" aria-labelledby="pendente-tab">
					<div class="card">
						<div class="card-body">
							<div class="row p-2">
								<div class="col-4 text-left ml-2 mt-1">
									<!--
									<el-tooltip content="Selecionar Todos" placement="top">
										<input v-show="listaUsuarioPendente.length > 0" type="checkbox" @change="checkAll"
											v-model="checkedUsersAll" />
									</el-tooltip>
									-->
								</div>
								<div class="col-4 text-right ">
									<!--
									<el-tooltip content="Aprovar todos os usuários selecionados" placement="top">
										<button type="button" class="btn btn-success" v-show="checkedUsers.length > 0"
											@click="aprovarTodos()">
											<i class="far fa-thumbs-up mr-2"></i>
											Aprovar Selecionados
										</button>
									</el-tooltip>
									-->
								</div>
								<div class="col text-right">
									<input class="form-control" placeholder="Pesquisar nome..." v-model="filtroPendente"
										@keyup="filtrarPendente" />
								</div>
							</div>

							<div id="accordionPendentes">
								<div class="card" v-for="(pendente, index) in listaUsuarioPendente"
									:key="pendente.idusuario">
									<div class="row">
										<div class="ml-2" style="background-color: rgba(0, 0, 0, 0.03); width: 30px">
											<!--
											<el-tooltip :content="`Selecionar ` + pendente.nome" placement="top">
												<input class="ml-3 mt-4" type="checkbox" id="checkbox" :value="pendente"
													v-model="checkedUsers" />
											</el-tooltip>
											-->
										</div>
										<div class="col" style="padding: 0 !important">
											<div class="card-header" @click="limparForm()" :id="`heading` + index"
												data-toggle="collapse" :data-target="`#collapse` + index"
												aria-expanded="true" :aria-controls="`collapse` + index">
												<h5 class="mb-0">
													<button class="btn btn-link">
														{{ pendente.nome }}
													</button>
												</h5>
											</div>
											<div :id="`collapse` + index" class="collapse" :class="{ show: index == 0 }"
												:aria-labelledby="`heading` + index" data-parent="#accordionPendentes">
												<div class="card-body">
													<div class="row">
														<div class="col-3" v-if="!edicao">
															<h4>{{ pendente.perfil }}</h4>
														</div>
														<div class="col-3 mt-4" v-if="edicao">
															<select class="form-control" v-model="altUsuario.profile"
																size="1" style="height: 40px">
																<option v-for="perfil in listaProfile" :key="perfil"
																	:value="perfil">
																	{{ perfil }}
																</option>
															</select>
														</div>
														<div class="col-5">
															<dt>Nome (apelido)</dt>
															<dd v-if="!edicao">
																{{ pendente.nome }} ({{ pendente.apelido }})
															</dd>
															<dd v-if="edicao">
																<div class="row">
																	<div class="col-7">
																		<input type="text" class="form-control"
																			v-model="altUsuario.nome" />
																	</div>
																	<div class="col-5">
																		<input type="text" class="form-control"
																			v-model="altUsuario.apelido" />
																	</div>
																</div>
															</dd>
															<dt v-if="edicao && habilita">Coordenação</dt>
															<dd v-if="edicao && habilita">
																<select class="form-control"
																	v-model="altUsuario.coordenacao" @change="carregarGTs">
																	<option v-for="coord in listaCoordenacao"
																		:key="coord.idcoordenacao" :value="coord">
																		{{ coord.nome }}
																	</option>
																</select>
															</dd>
															<dt>Grupo de Trabalho</dt>
															<dd v-if="!edicao">{{ (pendente.grupoTrabalho != null) ?
																pendente.grupoTrabalho.nome : 'nenhum grupo selecionado' }}
															</dd>
															<dd v-if="edicao">
																<select class="form-control"
																	v-model="altUsuario.grupoTrabalho">
																	<option v-for="gt in listaGTs" :key="gt.idgt"
																		:value="gt">
																		{{ gt.nome }}
																	</option>
																</select>
															</dd>
														</div>
														<div class="col-4">
															<dt>E-mail</dt>
															<dd>{{ pendente.email }}</dd>
															<dt>Data do Cadastro</dt>
															<dd>
																{{ pendente.dataCriacaoFmt }} -
																<small>{{ pendente.tempoCriacao }}</small>
															</dd>
														</div>
													</div>
													<div class="mt-4 text-center" v-if="!edicao">
														<!--
														<el-tooltip :content="`Aprovar o cadastro de ` + pendente.nome"
															placement="top">
															<button class="btn btn-success pl-5 pr-5"
																@click="aprovar(pendente)">
																<i class="far fa-thumbs-up"></i>
															</button>
														</el-tooltip>
														-->
														<el-tooltip :content="`Alterar o cadastro de ` + pendente.nome"
															placement="top">
															<button class="btn btn-primary pl-5 pr-5"
																@click="fazerAlteracao(pendente)">
																Alterar
															</button>
														</el-tooltip>
														<el-tooltip :content="`Reprovar o cadastro de ` + pendente.nome"
															placement="top">
															<button class="btn btn-danger pl-5 pr-5"
																@click="abrirModalReprovacao(pendente)">
																<i class="fas fa-thumbs-down"></i>
															</button>
														</el-tooltip>
													</div>
													<div class="mt-4 text-center" v-if="edicao">
														<el-tooltip
															:content="`Salvar e aprovar o cadastro de ` + pendente.nome"
															placement="top">
															<button class="btn btn-success" @click="salvarAprovar()">
																<i class="far fa-thumbs-up mr-3"></i>
																Salvar e Aprovar
															</button>
														</el-tooltip>
														<el-tooltip :content="`Apenas salvar o cadastro de ` + pendente.nome"
															placement="top">
															<button class="btn btn-info" @click="salvarAlteracao()">
																Apenas Salvar
															</button>
														</el-tooltip>
														<el-tooltip content="Desistir da alteração" placement="top">
															<button class="btn btn-danger" @click="desistirAlteracao()">
																Desistir
															</button>
														</el-tooltip>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Fim: Usuários Pendentes -->

				<!-- Usuários Ativos -->
				<div class="mt-2 tab-pane fade show" id="aprovados" role="tabpanel" aria-labelledby="aprovados-tab">
					<div class="card">
						<div class="card-body">
							<div class="row p-2">
								<div class="col-3">
									<select class="form-control" v-model="filtroAtivoCoord">
										<option value="">Coordenação</option>
										<option v-for="coord in listaCoordenacao" :key="coord.id" :value="coord">{{
											coord.nome }}</option>
									</select>
								</div>
								<div class="col-3">
									<select class="form-control" v-model="filtroAtivoGT">
										<option value="">Grupo de Trabalho</option>
										<option v-for="gt in listaGTs" :key="gt.id" :value="gt">{{ gt.nome }}</option>
									</select>
								</div>
								<div class="col-3">
									<select class="form-control" v-model="filtroAtivoProfile">
										<option value="">Perfil</option>
										<option v-for="perfil in listaProfile" :key="perfil" :value="perfil">
											{{ perfil }}
										</option>
									</select>
								</div>
								<div class="col-3 text-center">
									<el-tooltip content="Limpar Filtro da Pesquisa" placement="top">
										<a class="btn btn-light" @click.prevent="limparFiltro">
											<i class="fas fa-eraser mr-2"></i>
											Limpar
										</a>
									</el-tooltip>
									<el-tooltip content="Aplicar filtro na consulta" placement="top">
										<a class="btn btn-info" @click.prevent="aplicarFiltro">
											<i class="fas fa-filter mr-2"></i>
											Aplicar
										</a>
									</el-tooltip>
								</div>
							</div>
							<div class="row p-2">
								<div class="col-6">
									<input class="form-control" placeholder="Pesquisar nome..." v-model="filtroAtivo"
										@keyup="filtrarAtivos" />
								</div>
								<div class="col-1">
									<div class="custom-switch ml-2 mt-2 campoForm">
										<input type="checkbox" v-model="filtroAtivoSoAtivo" 
											@change="filtrarAtivosSoAtivos" class="custom-control-input" id="check1" />
										<label class="custom-control-label" for="check1">Ativo</label>
									</div>
								</div>
								<div class="col-1">
									<div class="custom-switch ml-2 mt-2 campoForm">
										<input type="checkbox" v-model="filtroAtivoSoInativo" 
											@change="filtrarAtivosSoInativos" class="custom-control-input" id="check2" />
										<label class="custom-control-label" for="check2">Inativo</label>
									</div>
								</div>
							</div>
							<br>
							<table class="table table-hover">
								<thead style="background-image: linear-gradient(to left, white, #f2f2f2)">
									<tr class="clickable">
										<th width="30%" @click="sort('nome')">Nome (Apelido) <i
												class="text-muted fas fa-sort mr-2"></i></th>
										<th width="20%" @click="sort('email')">E-mail <i
												class="text-muted fas fa-sort mr-2"></i></th>
										<th width="20%" @click="sort('descricaoGT')">Grupo de Trabalho <i
												class="text-muted fas fa-sort mr-2"></i></th>
										<th width="10%" @click="sort('profilesDescricao')">Perfil <i
												class="text-muted fas fa-sort mr-2"></i></th>
										<th width="10%" class="text-center">Ativo</th>
										<th width="10%"></th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="usuario in sortedUsuariosAtivos" :key="usuario.idusuario">
										<td style="vertical-align:middle;" width="30%">
											<span class="text-wrap">
												{{ usuario.nome }} ({{ usuario.apelido }})
											</span>
										</td>
										<td style="vertical-align:middle;" width="20%">
											<span class="text-wrap">
												{{ usuario.email }}
											</span>
										</td>
										<td style="vertical-align:middle;" width="20%">
											<!--<span class="text-wrap">
									{{usuario.grupoTrabalho.nome}}
								</span>-->
											<span class="text-wrap">
												<span v-show="filtroGT" v-html="usuario.gtDescricao"></span>
												<span v-show="!filtroGT" v-html="usuario.grupoTrabalho.nomeComCoord"></span>	
											</span>
										</td>
										<td style="vertical-align:middle;" width="10%">
											<span v-show="filtroPerfil" v-html="usuario.profilesDescricao"></span>
											<span v-show="!filtroPerfil" v-html="usuario.perfil"></span>
										</td>
										<td style="vertical-align:middle;" width="10%" class="text-center">
											<i v-if="usuario.isAtivo" class="fas fa-check-circle text-success"></i>
											<i v-if="!usuario.isAtivo" class="fas fa-minus"></i>
										</td>
										<td style="vertical-align:middle;" width="10%" class="text-center">
											<el-tooltip :content="`Alterar dados de ` + usuario.nome" placement="top">
												<i class="fas fa-edit pr-2 pl-2 text-warning clickable"
													@click="abrirModalAltUsuario(usuario)"></i>
											</el-tooltip>
											<el-tooltip :content="`Reiniciar a senha de ` + usuario.nome" placement="top">
												<i class="fas fa-key pr-2 pl-2 clickable"
													@click="reiniciarSenha(usuario)"></i>
											</el-tooltip>
											<el-tooltip v-if="usuario.isAtivo" :content="`Desativar ` + usuario.nome"
												placement="top">
												<i class="
										far
										fa-trash-alt
										pr-2
										pl-2
										text-danger
										clickable
									" @click="excluirUsuario(usuario)"></i>
											</el-tooltip>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<!-- Fim: Usuários Aprovados -->
			</div>
		</div>

		<modal :show.sync="modals.modalReprovacao">
			<form class="ml-3 mt-3 mr-3 mb-3">
				<h4 class="text-center">
					Reprovar cadastro de {{ altUsuario.apelido }}
				</h4>
				<div>
					<dt>Nome</dt>
					<dd>{{ altUsuario.nome }}</dd>
				</div>
				<div>
					<dt>E-mail</dt>
					<dd>{{ altUsuario.email }}</dd>
				</div>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-align-left w-14"></i></span>
					</div>
					<textarea class="form-control mb-2" v-model="justificativa" placeholder="Justificativa"></textarea>
				</div>

				<br class="clear" />
				<div class="col-md-12 text-center mt-3">
					<button type="button" class="btn btn-danger" @click="fecharModal">
						Desistir
					</button>
					<button type="button" class="btn btn-primary ml-4" @click="cancelarCadastro()">
						Cancelar cadastro
					</button>
				</div>
			</form>
		</modal>

		<modal :show.sync="modals.modalUsuario">
			<form class="ml-3 mt-3 mr-3 mb-3">
				<h4 class="text-center">{{ opcao.label }} Usuário</h4>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-align-left w-14"></i></span>
					</div>
					<input type="text" class="form-control mb-2" v-model="usuario.nome" placeholder="Nome" />
				</div>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-align-left w-14"></i></span>
					</div>
					<input type="text" class="form-control mb-2" v-model="usuario.apelido" placeholder="Apelido" />
				</div>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-at w-14"></i></span>
					</div>
					<input type="text" class="form-control mb-2" v-model="usuario.email" placeholder="E-mail" />
				</div>
				<div class="input-group">
					<div class="input-group-prepend mb-2" style="height: 34px">
						<span class="input-group-text">
							<i class="fas fa-shield-alt w-14"></i>
						</span>
					</div>
					<v-select class="campoMultiplo mb-2" placeholder="Perfil" v-model="usuario.profile"
						:options="listaProfile">
						<span slot="no-options" @click="$refs.select.open = false">
							Nenhum registro encontrado
						</span>
					</v-select>
				</div>
				<div class="text-left mb-2">
					<div class="custom-switch ml-2 mt-1 campoForm">
						<input type="checkbox" v-model="perfilSecundario" class="custom-control-input"
							id="perfilSecundario" />
						<label class="custom-control-label" for="perfilSecundario"></label>
						Cadastrar Perfis secundários
					</div>
				</div>
				<div class="input-group" v-show="perfilSecundario">
					<div class="input-group-prepend mb-2" style="height: 34px">
						<span class="input-group-text"><i class="fas fa-user-shield w-14"></i></span>
					</div>
					<v-select id="TESTE1" class="campoMultiplo mb-2" placeholder="Lista de Perfil" multiple v-model="perfissecundarios"
						:options="listaProfile">
						<span slot="no-options" @click="$refs.select.open = false">
							Nenhum registro encontrado
						</span>
					</v-select>
				</div>

				<div class="input-group">
					<div class="input-group-prepend mb-2" style="height: 34px">
						<span class="input-group-text"><i class="fas fa-user-circle w-14"></i></span>
					</div>
					<v-select class="campoMultiplo mb-2" :reduce="(gt) => gt" label="nomeComCoord" 
							placeholder="Grupo trabalho"
							v-model="usuario.grupoTrabalho" :options="listaGTs">
						<span slot="no-options" @click="$refs.select.open = false">
							Nenhum registro encontrado
						</span>
					</v-select>
				</div>
				<div class="text-left mb-2">
					<div class="custom-switch ml-2 mt-1 campoForm">
						<input type="checkbox" v-model="gtSecundario" class="custom-control-input" id="gtSecundario" />
						<label class="custom-control-label" for="gtSecundario"></label>
						Cadastrar Grupos de Trabalho secundários
					</div>
				</div>
				<div class="input-group" v-show="gtSecundario">
					<div class="input-group-prepend mb-2" style="height: 34px">
						<span class="input-group-text"><i class="fas fa-users w-14"></i></span>
					</div>
					<v-select id="TESTE2" class="campoMultiplo mb-2" multiple label="nome" v-model="gtssecundarios" :options="listaGTs">
						<span slot="no-options" @click="$refs.select.open = false">
							Nenhum registro encontrado
						</span>
					</v-select>
				</div>
				<div class="input-group">
					<div class="input-group-prepend mb-2">
						<span class="input-group-text"><i class="fas fa-toggle-off w-14"></i></span>
					</div>
					<div class="col-2 custom-switch ml-2 mt-1 campoForm">
						<input type="checkbox" v-model="usuario.isAtivo" class="custom-control-input" id="check3" />
						<label class="custom-control-label" for="check3">Ativo</label>
					</div>
				</div>
				<br class="clear" />
				<div class="col-md-12 text-center mt-3">
					<button type="button" class="btn btn-danger" @click="fecharModal">
						Desistir
					</button>
					<button type="button" class="btn btn-primary ml-4" @keypress.enter="manterUsuario()"
						@click="manterUsuario()">
						{{ opcao.name }}
					</button>
				</div>
			</form>
		</modal>

	</div>
</template>

<script>
import "vue-select/dist/vue-select.css";

export default {
	components: {},
	created() {
		this.carregarUsuariosPendentes();
		this.carregarUsuariosAtivos();
		this.carregarCoordenacoes();
		this.carregarGTs();
	},
	computed: {
		sortedUsuariosAtivos: function () {
			return this.listaUsuarioAtivos.sort((a, b) => {
				let modifier = 1;
				if (this.currentSortDir === 'desc') modifier = -1;
				if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
				if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
				return 0;
			});
		}
	},
	data() {
		return {
			filtroPerfil: true,
			habilita: false,
			filtroGT: true,
			progress: true,
			edicao: false,
			altUsuario: {},
			listaUsuarioPendente: [],
			listaUsuarioPendenteFiltro: [],
			listaUsuarioAtivos: [],
			listaUsuarioAtivosAux: [],
			listaUsuarioAtivosFiltro: [],
			checkedUsersAll: false,
			checkedUsers: [],
			listaCoordenacao: [],
			listaGTs: [],
			listaComboGTs: [],
			listaProfileSelecionado: [],
			listaProfile: [],
			justificativa: "",
			currentSort: 'titulo',
			currentSortDir: 'asc',
			filtroPendente: "",
			filtroAtivo: "",
			filtroAtivoGT: "",
			filtroAtivoCoord: "",
			filtroAtivoProfile: "",
			filtroAtivoSoAtivo: false,
			filtroAtivoSoInativo: false,
			listaTipos: [],
			perfissecundarios: [],
			gtssecundarios: [],
			modals: {
				modalReprovacao: false,
				modalUsuario: false,
			},
			usuario: {
				dataCriacao: null,
				idusuario: null,
				isAtivo: true,
				isUsuarioLead: false,
				nome: null,
				apelido: null,
				email: "",
				grupoTrabalho: null,
				profile: null,
				listaProfile: [],
				listaGT: [],
			},
			opcao: {
				label: "Adicionar",
				name: "Incluir",
			},
			gtSecundario: false,
			perfilSecundario: false,
		};
	},
	methods: {
		sort: function (s) {
			if (s === this.currentSort) {
				this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = s;
		},
		filtrarPendente() {
			if (this.filtroPendente === "") {
				this.listaUsuarioPendente = this.listaUsuarioPendenteFiltro;
			} else {
				this.listaUsuarioPendente = this.listaUsuarioPendenteFiltro.filter(
					(item) => {
						return (
							item.nome
								.toUpperCase()
								.indexOf(this.filtroPendente.toUpperCase()) >= 0 ||
							item.apelido
								.toUpperCase()
								.indexOf(this.filtroPendente.toUpperCase()) >= 0 ||
							item.email
								.toUpperCase()
								.indexOf(this.filtroPendente.toUpperCase()) >= 0 ||
								//item.grupoTrabalho.nome.toUpperCase().indexOf(this.filtroPendente.toUpperCase())>=0 ||
							item.profile
								.toUpperCase()
								.indexOf(this.filtroPendente.toUpperCase()) >= 0
						);
					}
				);
			}
		},
		habilitaCoordenacao(habilita){
			this.habilita = habilita
		},
		aplicarFiltro() {
			this.progress = true;
			let filtro = {
				coordenacao: (this.filtroAtivoCoord == "") ? null : this.filtroAtivoCoord.idcoordenacao,
				grupoTrabalho: (this.filtroAtivoGT == "") ? null : this.filtroAtivoGT.idgt,
				perfil: (this.filtroAtivoProfile == "") ? null : this.filtroAtivoProfile,
				ativo: (this.filtroAtivoSoAtivo == "") ? false : this.filtroAtivoSoAtivo,
				inativo: (this.filtroAtivoSoInativo == "") ? false : this.filtroAtivoSoInativo,
			}
			this.$clubApi.post("/lead/ativos/filtro", filtro).then((response) => {
				this.listaUsuarioAtivos = [];
				this.listaUsuarioAtivosAux = response.data.object;
				this.listaUsuarioAtivosFiltro = response.data.object;

				this.listaUsuarioAtivosAux.forEach((data) => {
					data.descricaoGT = data.grupoTrabalho.nome
					if (data.profiles.length > 0) {
						data.possuiPerfis = true;
					} else {
						data.possuiPerfis = false;
					}
					if (data.grupotrabalho.length > 0) {
						data.possuiGTs = true;
					} else {
						data.possuiGTs = false;
					}
					data.listaProfile = [];
					data.listaGT = [];
					this.listaUsuarioAtivos.push(data);
				});
			})
			.catch((error) => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
		filtrarAtivos() {
			if (this.filtroAtivo === "") {
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro;
			} else {
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro.filter(
					(item) => {
						return (
							item.nome.toUpperCase().indexOf(this.filtroAtivo.toUpperCase()) >=
							0 ||
							item.apelido
								.toUpperCase()
								.indexOf(this.filtroAtivo.toUpperCase()) >= 0 ||
							item.email
								.toUpperCase()
								.indexOf(this.filtroAtivo.toUpperCase()) >= 0 ||
							//item.grupoTrabalho.nome.toUpperCase().indexOf(this.filtroAtivo.toUpperCase())>=0 ||
							item.profile
								.toUpperCase()
								.indexOf(this.filtroAtivo.toUpperCase()) >= 0
						);
					}
				);
			}
		},
		filtrarAtivosSoAtivos() {
			if (this.filtroAtivoSoAtivo === "" || !this.filtroAtivoSoAtivo) {
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro;
			} else {
				this.filtroAtivoSoInativo = false
				this.listaUsuarioAtivos = [];
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro.filter(
					(item) => {
						return (item.isAtivo);
					}
				);
			}
		},

		filtrarAtivosSoInativos() {
			if (this.filtroAtivoSoInativo === "" || !this.filtroAtivoSoInativo) {
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro;
			} else {
				this.filtroAtivoSoAtivo = false;
				this.listaUsuarioAtivos = [];
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro.filter(
					(item) => {
						return (!item.isAtivo);
					}
				);
			}
		},

		/**
		filtrarAtivosGT() {
			if (this.filtroAtivoGT === "") {
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro;
				this.filtroGT = true;
			} else {
				this.filtroGT = false;
				this.filtroAtivoCoord = "";
				this.filtroAtivoProfile = "";
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro;
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro.filter(
					(item) => {
						return (item.grupoTrabalho.idgt == this.filtroAtivoGT.idgt);
					}
				);
			}
		},
		filtrarAtivosCoord() {
			if (this.filtroAtivoCoord === "") {
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro;
			} else {
				this.filtroAtivoGT = "";
				this.filtroAtivoProfile = "";
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro;
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro.filter(
					(item) => {
						return (item.grupoTrabalho.coordenacao.idcoordenacao == this.filtroAtivoCoord.idcoordenacao
							|| item.grupoTrabalho.coordenacao == this.filtroAtivoCoord.idcoordenacao);
					}
				);
			}
		},
		filtrarAtivosProfile() {
			if (this.filtroAtivoProfile === "") {
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro;
				this.filtroPerfil = true;
			} else {
				this.filtroAtivoGT = "";
				this.filtroAtivoCoord = "";
				this.filtroPerfil = false;
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro;
				this.listaUsuarioAtivos = this.listaUsuarioAtivosFiltro.filter(
					(item) => {
						return item.profile == this.filtroAtivoProfile;
					}
				);
			}
		},
		*/
		carregarUsuariosPendentes() {
			this.$clubApi.get("/lead").then((response) => {
				this.listaUsuarioPendente = response.data.object;
				this.listaUsuarioPendenteFiltro = response.data.object;
			})
			.catch((error) => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
		carregarUsuariosAtivos() {
			this.listaUsuarioAtivos = [];
			this.$clubApi.get("/user").then((response) => {
				this.listaUsuarioAtivosAux = response.data.object;
				this.listaUsuarioAtivosFiltro = response.data.object;
				this.$clubApi.get("/enum/profile").then((response) => {
					this.listaProfile = response.data.object;
				});
				this.listaUsuarioAtivosAux.forEach((data) => {
					data.descricaoGT = data.grupoTrabalho.nome
					if (data.profiles.length > 0) {
						data.possuiPerfis = true;
					} else {
						data.possuiPerfis = false;
					}
					if (data.grupotrabalho.length > 0) {
						data.possuiGTs = true;
					} else {
						data.possuiGTs = false;
					}
					data.listaProfile = [];
					data.listaGT = [];
					this.listaUsuarioAtivos.push(data);
				});
			})
			.catch((error) => {
				this.$toastr.error(error.response.data.msg);
			})
			.finally(() => {
				this.progress = false;
			});
		},
		abrirModalAddUsuario() {
			this.progress = true;
			this.limparUsuario();
			// this.listaComboGTs = this.listaGTs.map( (gt) => {
			// 	return { nome: gt.nome, idgt: gt.idgt }
			// });
			this.$clubApi.get('/estrutura/gt/ativo').then(response => {
				this.opcao.label = "Adicionar";
				this.opcao.name = "Incluir";
				this.modals.modalUsuario = true;
				this.listaGTs = response.data.object;
			})
				.catch((error) => {
					this.$toastr.error(error.response.data.msg);
				})
				.finally(() => {
					this.progress = false;
				});
		},
		abrirModalAltUsuario(usuario) {
			this.progress = true;
			usuario.listaProfile = [];
			usuario.listaGT = [];
			this.perfissecundarios = [];
			this.gtssecundarios = [];
			this.$clubApi.get('/estrutura/gt/ativo').then(response => {
				if (usuario.possuiPerfis) {
					usuario.profiles.forEach(pfl => {
						this.perfissecundarios.push(pfl.nome);
					});
				}

				if (usuario.possuiGTs) {
					usuario.grupotrabalho.forEach(gts => {
						this.gtssecundarios.push(gts.nome);
					});
				}

				this.listaGTs = response.data.object;
				this.usuario = usuario;

				// Definir gtSecundario e perfilSecundario aqui
				this.gtSecundario = usuario.possuiGTs;
				this.perfilSecundario = usuario.possuiPerfis;

				this.opcao.label = "Alterar";
				this.opcao.name = "Alterar";
				this.modals.modalUsuario = true;

			}).catch((error) => {
				this.$toastr.error(error.response.data.msg);
			}).finally(() => {
				this.progress = false;
			});
		},
		abrirModalReprovacao(usuario) {
			this.altUsuario = usuario;
			this.modals.modalReprovacao = true;
		},
		fecharModal() {
			this.modals.modalReprovacao = false;
			this.modals.modalUsuario = false;
		},
		cancelarCadastro() {
			if (this.justificativa.trim() == "") {
				this.$toastr.warning("Necessário preencher a justificativa!");
			} else {
				this.modals.modalReprovacao = false;
				const options = {
					title: "Confirmação",
					okLabel: "Confirmar",
					cancelLabel: "Não",
				};
				this.$dialogs
					.confirm(
						'Deseja realmente cancelar o cadastro de "' +
						this.altUsuario.nome +
						'"? Após essa confirmação o cadastro será excluído definitivamente.',
						options
					)
					.then((res) => {
						if (res.ok) {
							let cancelar = {
								idUsuario: this.altUsuario.idusuario,
								justificativa: this.justificativa,
							};
							this.$clubApi
								.post("/lead/cancelar", cancelar)
								.then(() => {
									this.$toastr.success("Cadastro cancelado com sucesso!");
									this.carregarUsuariosPendentes();
									this.carregarUsuariosAtivos();
									this.justificativa = "";
								})
								.catch((error) => {
									this.$toastr.error(error.response.data.msg);
								})
								.finally(() => {
									//NProgress.done();
								});
						}
					});
			}
		},
		validaEntrada() {
			var countError = 0;

			if (this.usuario.grupoTrabalho == null || this.usuario.grupoTrabalho == "") {
				this.$toastr.error("Grupo de trabalho obrigatório!");
				countError++;
			}

			if (this.usuario.profile == null || this.usuario.profile == "") {
				this.$toastr.error("Perfil obrigatório!");
				countError++;
			}

			if (this.usuario.email == null || this.usuario.email == "") {
				this.$toastr.error("E-mail obrigatório!");
				countError++;
			}

			if (this.usuario.apelido == null || this.usuario.napelidoome == "") {
				this.$toastr.error("Apelido obrigatório!");
				countError++;
			}

			if (this.usuario.nome == null || this.usuario.nome == "") {
				this.$toastr.error("Nome obrigatório!");
				countError++;
			}
			return countError == 0;

		},
		manterUsuario() {
			if (!this.validaEntrada()) {
				return;
			}
			this.modals.modalUsuario = false;
			const options = {
				title: "Confirmação",
				okLabel: this.opcao.name,
				cancelLabel: "Não",
			};
			this.$dialogs
				.confirm(
					"Deseja realmente " + this.opcao.name.toLowerCase() + " o usuário?",
					options
				)
				.then((res) => {
					if (res.ok) {
						this.progress = true;
						this.usuario.listaProfile = this.perfissecundarios;
						this.usuario.listaGT = this.obtemCodigosGTSecundarios();
						this.$clubApi.post("/user", this.usuario)
							.then(() => {
								this.$toastr.success("Cadastro realizado com sucesso!");
								this.limparUsuario();
								this.carregarUsuariosAtivos();
							})
							.catch((error) => {
								this.$toastr.error(error.response.data.msg);
							})
							.finally(() => {
								this.progress = false;
							});
					}
				});
		},
		obtemCodigosGTSecundarios() {
			var codGT = [];
			if (this.gtssecundarios.length > 0 && this.gtSecundario) {
				for (let i = 0; i < this.gtssecundarios.length; i++) {
					for (let j = 0; j < this.listaGTs.length; j++) {

						if (this.gtssecundarios[i].nome !== undefined) {
							if (this.gtssecundarios[i].nome === this.listaGTs[j].nome) {
								codGT.push(this.listaGTs[j].idgt)
							}
						} else {
							if (this.gtssecundarios[i] === this.listaGTs[j].nome) {
								codGT.push(this.listaGTs[j].idgt)
							}
						}
					}
				}
			}
			return codGT;
		},
		criaUsuarioRequest() {
			this.usuarioManter.id = this.usuario.idusuario;
			this.usuarioManter.apelido = this.usuario.apelido;
			this.usuarioManter.email = this.usuario.email;
			this.usuarioManter.nome = this.usuario.nome;
			var list = [];
			var profile = null;
			this.listaProfileSelecionado.map(function (value, key) {
				profile = {
					id: null,
					descricao: "",
				}
				profile.id = key;
				profile.descricao = value;
				list.push(profile);
			});
			this.usuarioManter.listaProfile = list;
			this.usuarioManter.profile = this.usuario.profile;
			this.usuarioManter.gtprincipal = this.usuario.gtprincipal;
		},
		excluirUsuario(usuario) {
			const options = {
				title: "Confirmação",
				okLabel: "Desativar",
				cancelLabel: "Não",
			};
			this.$dialogs
				.confirm(
					'Deseja realmente desativar o usuário "' + usuario.nome + '"?',
					options
				)
				.then((res) => {
					if (res.ok) {
						this.$clubApi
							.delete("/user/" + usuario.idusuario)
							.then(() => {
								this.$toastr.success("Usuário apagado com sucesso!");
								this.carregarUsuariosAtivos();
							})
							.catch((error) => {
								this.$toastr.error(error.response.data.msg);
							})
							.finally(() => {
								//NProgress.done();
							});
					}
				});
		},
		reiniciarSenha(usuario) {
			const options = {
				title: "Confirmação",
				okLabel: "Reiniciar",
				cancelLabel: "Não",
			};
			this.$dialogs
				.confirm('Deseja reiniciar a senha de "' + usuario.nome + '"?', options)
				.then((res) => {
					if (res.ok) {
						this.$clubApi
							.post("/user/reiniciar/" + usuario.idusuario)
							.then(() => {
								this.$toastr.success("Senha reiniciada com sucesso! E-mail enviado ao usuário!");
							})
							.catch((error) => {
								this.$toastr.error(error.response.data.msg);
							})
							.finally(() => {
								//NProgress.done();
							});
					}
				});
		},
		carregarGTs() {
			this.$clubApi.get('/estrutura/gt/ativo').then(response => {
				this.listaGTs = response.data.object;
			})
				.catch((error) => {
					this.$toastr.error(error.response.data.msg);
				})
				.finally(() => {
					this.progress = false;
				});
		},
		carregarCoordenacoes() {
			this.$clubApi.get("/estrutura/coord/ativo").then((response) => {
				this.listaCoordenacao = response.data.object;
			})
				.catch((error) => {
					this.$toastr.error(error.response.data.msg);
				})
				.finally(() => {
					this.progress = false;
				});
		},
		async fazerAlteracao(usuario) {
			this.altUsuario = usuario;
			this.edicao = true;
		},
		salvarAlteracao() {
			if (this.validarUsuario()) {
				const options = {
					title: "Confirmação",
					okLabel: "Apenas salvar",
					cancelLabel: "Não",
				};
				this.$dialogs.confirm('Deseja salvar o cadastro de "' + this.altUsuario.nome + '"?', options)
					.then((res) => {
						if (res.ok) {
							this.salvarAlteracaoUsuario(true);
						}
					});
			}
		},
		salvarAlteracaoUsuario(mensagem) {
			if (this.validarUsuario()) {
				this.progress = true;
				this.$clubApi.post("/lead/salvar", this.altUsuario).then(() => {
					if (mensagem)
						this.$toastr.success("Dados salvos com sucesso!");
					this.limparFiltro()
					this.carregarUsuariosPendentes();
					this.carregarUsuariosAtivos();
					this.filtroPendente = "";
					this.edicao = false;
				})
					.catch((error) => {
						this.$toastr.error(error.response.data.msg);
					})
					.finally(() => {
						this.progress = false;
					});
			}
		},

		salvarUsuarioAprovado(mensagem) {
			if (this.validarUsuario()) {
				this.progress = true;
				this.altUsuario.idGt = this.altUsuario.grupoTrabalho.idgt;
				this.$clubApi.post("/lead/salvarpendente", this.altUsuario).then(() => {
					if (mensagem)
						this.$toastr.success("Dados salvos com sucesso!");
					this.limparFiltro()
					this.carregarUsuariosPendentes();
					this.carregarUsuariosAtivos();
					this.filtroPendente = "";
					this.edicao = false;
					this.aprovarUsuario(this.altUsuario);
				})
					.catch((error) => {
						this.$toastr.error(error.response.data.msg);
					})
					.finally(() => {
						this.progress = false;
					});
			}
		},

		salvarAprovar() {
			if (this.validarUsuario()) {
				const options = {
					title: "Confirmação",
					okLabel: "Salvar e aprovar",
					cancelLabel: "Não",
				};
				this.$dialogs.confirm('Deseja Salvar e Aprovar "' + this.altUsuario.nome +
					'"? Após essa aprovação, o usuário estará ativo para acessar o sistema.',
					options
				).then(async (res) => {
					if (res.ok) {
						await this.salvarUsuarioAprovado(false);
						//await this.aprovarUsuario(this.altUsuario);
					}
				});
			}
		},
		aprovar(usuario) {
			if (this.validarDadosUsuario(usuario)) {
				const options = {
					title: "Confirmação",
					okLabel: "Aprovar",
					cancelLabel: "Não",
				};
				this.$dialogs.confirm('Deseja aprovar o cadastro de "' +
					usuario.nome + '"? Após essa aprovação, o usuário estará ativo para acessar o sistema.',
					options
				).then((res) => {
					if (res.ok) {
						this.aprovarUsuario(usuario);
					}
				});
			}
		},
		aprovarUsuario(usuario) {
			if (this.validarUsuario()) {
				this.progress = true;
				this.$clubApi.post("/lead/aprovar/" + usuario.idusuario).then(() => {
					this.$toastr.success("Usuário aprovado com sucesso!");
					this.carregarUsuariosPendentes();
					this.carregarUsuariosAtivos();
				})
					.catch((error) => {
						this.$toastr.error(error.response.data.msg);
					})
					.finally(() => {
						this.progress = false;
					});
			}
		},
		// Validar os dados do Usuario enquanto está editando o formulario (edicao == true)
		validarUsuario() {
			if (!this.altUsuario.nome && this.altUsuario.nome == "") {
				this.$toastr.error("Nome é preenchimento obrigatório");
				return false;
			}
			if (!this.altUsuario.apelido && this.altUsuario.apelido == "") {
				this.$toastr.error("Apelido é preenchimento obrigatório");
				return false;
			}
			if (this.altUsuario.grupoTrabalho == null || this.altUsuario.grupoTrabalho == "" || this.altUsuario.grupoTrabalho.idgt == 1) {
				this.$toastr.error("Grupo de Trabalho é preenchimento obrigatório");
				return false;
			}
			return true;
		},
		// Validar os dados do usuário já preenchido tudo (edicao == false)
		validarDadosUsuario(usuario) {
			if (usuario.nome == "") {
				this.$toastr.error("Nome é preenchimento obrigatório");
				return false;
			}
			if (usuario.apelido == "") {
				this.$toastr.error("Apelido é preenchimento obrigatório");
				return false;
			}
			if (usuario.grupoTrabalho == null || usuario.grupoTrabalho == "") {
				this.$toastr.error("Grupo de Trabalho é preenchimento obrigatório");
				return false;
			}
			return true;
		},
		validarListaUsuario(listaUsuario) {
			let retorno = true;
			for (const usuario of listaUsuario) {
				retorno = this.validarDadosUsuario(usuario);
				if (!retorno)
					break;
			}
			return retorno;
		},
		aprovarTodos() {
			if (this.checkedUsers.length > 0) {

				if (this.validarListaUsuario(this.checkedUsers)) {
					const options = {
						title: "Confirmação",
						okLabel: "Aprovar",
						cancelLabel: "Não",
					};
					this.$dialogs.confirm("Deseja aprovar o cadastro de " +
						this.checkedUsers.length +
						" usuários? Após essa aprovação, os usuários estarão ativos para acessar o sistema.",
						options
					).then((res) => {
						if (res.ok) {
							this.progress = true;
							this.$clubApi.post("/lead/aprovarTodos", this.checkedUsers).then(() => {
								this.$toastr.success("Usuários aprovados com sucesso!");
								this.carregarUsuariosPendentes();
								this.carregarUsuariosAtivos();
							})
								.catch((error) => {
									this.$toastr.error(error.response.data.msg);
								})
								.finally(() => {
									this.progress = false;
								});
						}
					});
				}
			}
		},
		desistirAlteracao() {
			this.edicao = false;
		},
		checkAll() {
			if (this.checkedUsersAll) {
				this.listaUsuarioPendente.forEach((u) => {
					this.checkedUsers.push(u);
				});
			} else {
				this.checkedUsers = [];
			}
		},
		limparForm() {
			this.altUsuario = {};
			this.justificativa = "";
			this.edicao = false;
		},
		limparUsuario() {
			this.usuario = {};
			this.gtSecundario = false;
			this.perfilSecundario = false;
			this.gtSecundario = false;
		},
		limparFiltro() {
			this.filtroAtivoCoord = "";
			this.filtroAtivoGT = "";
			this.filtroAtivoProfile = "";
			this.filtroAtivo = "";
			this.filtroAtivoSoAtivo = false;
			this.aplicarFiltro();
		}
	},
};
</script>
<style scoped>
.container-fluid { padding-left: 10px !important; padding-right: 10px !important; }
.clickable {
	cursor: pointer;
}

.campoMultiplo {
	width: 90%;
}

.w-14 {
	width: 14px;
}

.nav {
	display: -ms-flexbox;
	display: -webkit-box;
	display: flex;
	-ms-flex-wrap: wrap;
	flex-wrap: wrap;
	padding-left: 0;
	margin-bottom: -9px;
	list-style: none;
}
</style>